document.addEventListener('DOMContentLoaded', function() {
    if (!document.body.classList.contains('sj-24k-gold-dipped-rose')) return;
    
    function syncSwatch() {
        const variantSelect = document.querySelector('.product-form__input .select__select');
        if (!variantSelect) return;
        
        const selectedText = variantSelect.options[variantSelect.selectedIndex].textContent.trim().toLowerCase();
        
        document.querySelectorAll('.tpo_image-swatches-wrapper.below_value.tpo_image-swatch-hover').forEach(function(wrapper) {
            const radio = wrapper.querySelector('.tpo_image-swatches-input');
            if (!radio) return;
            
            if (radio.value.trim().toLowerCase() === selectedText) {
                radio.checked = true;
                document.querySelectorAll('.tpo_image-swatches-wrapper').forEach(w => w.classList.remove('tpo_is_checked_swatches'));
                wrapper.classList.add('tpo_is_checked_swatches');
            }
        });
    }
    
    function handleSelection(wrapper) {
        const radio = wrapper.querySelector('.tpo_image-swatches-input');
        if (!radio) return;
        
        const swatchValue = radio.value.trim().toLowerCase();
        const variantSelect = document.querySelector('.product-form__input .select__select');
        if (!variantSelect) return;
        
        // 1. Change variation dropdown
        for (let i = 0; i < variantSelect.options.length; i++) {
            if (variantSelect.options[i].textContent.trim().toLowerCase() === swatchValue) {
                variantSelect.selectedIndex = i;
                variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
                break;
            }
        }
        
        // 2. Change visual active class instantly
        radio.checked = true;
        document.querySelectorAll('.tpo_image-swatches-wrapper').forEach(w => w.classList.remove('tpo_is_checked_swatches'));
        wrapper.classList.add('tpo_is_checked_swatches');
    }
    
    const setupInterval = setInterval(function() {
        const swatches = document.querySelectorAll('.tpo_image-swatches-wrapper.below_value.tpo_image-swatch-hover');
        
        if (swatches.length > 0) {
            syncSwatch();
            
            // Variables to track movement thresholds
            let touchStartX = 0;
            let touchStartY = 0;
            let isScrolling = false;

            swatches.forEach(function(swatch) {
                // Record the starting point of the touch
                swatch.addEventListener('touchstart', function(e) {
                    touchStartX = e.touches[0].clientX;
                    touchStartY = e.touches[0].clientY;
                    isScrolling = false; // Reset tracking flag
                }, { passive: true });

                // Check if the user is moving their finger to scroll
                swatch.addEventListener('touchmove', function(e) {
                    const currentX = e.touches[0].clientX;
                    const currentY = e.touches[0].clientY;
                    
                    // If finger moved more than 8 pixels vertically or horizontally, consider it a scroll
                    if (Math.abs(currentX - touchStartX) > 8 || Math.abs(currentY - touchStartY) > 8) {
                        isScrolling = true;
                    }
                }, { passive: true });

                // Fire selection on release, ONLY if they didn't scroll
                swatch.addEventListener('touchend', function(e) {
                    if (!isScrolling) {
                        e.preventDefault(); // Stop sticky hover & double tap delay
                        handleSelection(this);
                    }
                });

                // Desktop mouse fallback
                swatch.addEventListener('click', function(e) {
                    e.preventDefault();
                    handleSelection(this);
                });
            });
            
            clearInterval(setupInterval);
        }
    }, 300);

    const variantSelect = document.querySelector('.product-form__input .select__select');
    if (variantSelect) {
        variantSelect.addEventListener('change', syncSwatch);
    }
});